enum Fraud {
  PBPAYUnknownFraudCheck = "PBPAYUnknownFraudCheck",
  PBPAYInvalidFraudCheckType = "PBPAYInvalidFraudCheckType",
  PBPAYFraudThresholdHit = "PBPAYFraudThresholdHit",
  PBPAYDuplicateFraudCheck = "PBPAYDuplicateFraudCheck",
  PBPAYInvalidFraudCheck = "PBPAYInvalidFraudCheck"
}

export default Fraud
